import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { EventEmitter } from 'events';
import { keys } from '../utils/utils';
import { MatrixRoomStatus } from './models/MatrixRoom';
import { MatrixClientEventType } from './models/MatrixClientEvent';
export var MatrixClientEventEmitter = /*#__PURE__*/function (_EventEmitter) {
  _inherits(MatrixClientEventEmitter, _EventEmitter);

  var _super = _createSuper(MatrixClientEventEmitter);

  function MatrixClientEventEmitter() {
    var _this;

    _classCallCheck(this, MatrixClientEventEmitter);

    _this = _super.apply(this, arguments);
    _this.eventEmitProviders = new Map([[MatrixClientEventType.INVITE, function () {
      return [_this.isInvite, _this.emitInvite.bind(_assertThisInitialized(_this))];
    }], [MatrixClientEventType.MESSAGE, function () {
      return [_this.isMessage, _this.emitMessage.bind(_assertThisInitialized(_this))];
    }]]);
    return _this;
  }
  /**
   * This method is called every time the state is changed
   *
   * @param _oldState
   * @param _newState
   * @param stateChange
   */


  _createClass(MatrixClientEventEmitter, [{
    key: "onStateChanged",
    value: function onStateChanged(_oldState, _newState, stateChange) {
      var _iterator = _createForOfIteratorHelper(keys(MatrixClientEventType)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var event = _step.value;
          this.emitIfEvent(MatrixClientEventType[event], stateChange);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Emit the message if we have listeners registered for that type
     *
     * @param eventType
     * @param object
     */

  }, {
    key: "emitIfEvent",
    value: function emitIfEvent(eventType, object) {
      var provider = this.eventEmitProviders.get(eventType);

      if (provider) {
        var _provider = provider(),
            _provider2 = _slicedToArray(_provider, 2),
            predicate = _provider2[0],
            emitter = _provider2[1];

        if (predicate(object)) {
          emitter(eventType, object);
        }
      }
    }
    /**
     * Emit a client event
     *
     * @param eventType
     * @param content
     */

  }, {
    key: "emitClientEvent",
    value: function emitClientEvent(eventType, content, timestamp) {
      this.emit(eventType, {
        type: eventType,
        content: content,
        timestamp: timestamp
      });
    }
    /**
     * Check if event is an invite
     *
     * @param stateChange
     */

  }, {
    key: "isInvite",
    value: function isInvite(stateChange) {
      return stateChange.rooms ? stateChange.rooms.some(function (room) {
        return room.status === MatrixRoomStatus.INVITED;
      }) : false;
    }
    /**
     * Emit an invite
     *
     * @param eventType
     * @param stateChange
     */

  }, {
    key: "emitInvite",
    value: function emitInvite(eventType, stateChange) {
      var _this2 = this;

      stateChange.rooms.filter(function (room) {
        return room.status === MatrixRoomStatus.INVITED;
      }).map(function (room) {
        return [room.id, room.members];
      }).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            id = _ref2[0],
            members = _ref2[1];

        _this2.emitClientEvent(eventType, {
          roomId: id,
          members: members
        });
      });
    }
    /**
     * Check if event is a message
     *
     * @param stateChange
     */

  }, {
    key: "isMessage",
    value: function isMessage(stateChange) {
      return stateChange.rooms ? stateChange.rooms.some(function (room) {
        return room.messages.length > 0;
      }) : false;
    }
    /**
     * Emit an event to all rooms
     *
     * @param eventType
     * @param stateChange
     */

  }, {
    key: "emitMessage",
    value: function emitMessage(eventType, stateChange) {
      var _this3 = this;

      stateChange.rooms.filter(function (room) {
        return room.messages.length > 0;
      }).map(function (room) {
        return room.messages.map(function (message) {
          return [room.id, message, message.timestamp];
        });
      }).reduce(function (flatten, toFlatten) {
        return flatten.concat(toFlatten);
      }, []).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 3),
            roomId = _ref4[0],
            message = _ref4[1],
            timestamp = _ref4[2];

        _this3.emitClientEvent(eventType, {
          roomId: roomId,
          message: message
        }, timestamp);
      });
    }
  }]);

  return MatrixClientEventEmitter;
}(EventEmitter);